export default __webpack_public_path__ + "static/media/eduImgWhite.ae822784.svg";